/* Sika 3D generator - material drawer (17 Oct 2026)
   Replaces the material dropdowns with a drawer like the fabric drawer on the product pages.
   Top: the chosen material of each part (click a part to show its options below).
   Picks are kept as a draft until "See model" applies them to the 3D model.
   Works on top of the generator's own dropdown lists, so all selection logic stays in the section. */
(function () {
  var PARTS_GROUPED = [
    { key: 'mixframe', label: 'Frame' },
    { key: 'mixpipe', label: 'Pipe' },
    { key: 'mixweave', label: 'Weave & bindings' }
  ];
  var PARTS_SINGLE = ['frame', 'pipe', 'bindings', 'seat', 'back'];

  function big(src) {
    if (!src) return src;
    return /[?&]width=\d+/.test(src) ? src.replace(/([?&])width=\d+/, '$1width=600') : src + (src.indexOf('?') < 0 ? '?' : '&') + 'width=600';
  }
  function splitName(n) {
    var i = (n || '').indexOf('|');
    return i < 0 ? [n || '', ''] : [n.slice(0, i).trim(), n.slice(i + 1).trim()];
  }

  // material wording (Exterior collection, Exterior 2026 catalogue p.129)
  function partKind(partKey) { return /frame/.test(partKey) ? 'frame' : /pipe/.test(partKey) ? 'pipe' : 'weave'; }
  function isExt(name) { return /\|\s*exterior/i.test(name || ''); }
  function handpainted(name) { return /^(antique|natural)\b/i.test(name || ''); }
  // short material line under a colour name in the drawer
  function matLabel(partKey, name) {
    if (!isExt(name)) return splitName(name)[1];
    if (partKind(partKey) === 'frame') return handpainted(name) ? 'Handpainted \u2013 Powdercoated Aluminum' : 'Powdercoated Aluminum';
    return 'ArtFibre\u00ae';
  }
  // longer material description shown on the page under the chosen materials
  var TXT_FRAME = 'Hand-bent aluminum frame, powder coated for a smooth finish. Well-suited to be left outside all year long, easy to clean and maintenance free.';
  var TXT_FRAME_HP = 'Hand-bent aluminum frame, powder coated and hand-painted. Well-suited to be left outside all year long, easy to clean and maintenance free.';
  var TXT_AF = 'ArtFibre\u00ae is made of dyed, hard-wearing polyethylene that is temperature and UV-resistant, making it ideal for outdoor use in any climate. It is flexible, comfortable when woven and keeps its shape for years.';

  function init(drawer) {
    var sid = drawer.getAttribute('data-section');
    var root = document.getElementById('cpg-' + sid);
    if (!root || drawer.__cpgInit) return;
    drawer.__cpgInit = true;
    var body = drawer.querySelector('[data-cpg-md-body]');
    var applyBtn = drawer.querySelector('[data-cpg-md-apply]');
    var st = null;

    function field(key) { return root.querySelector('[data-cpg-field="' + key + '"]'); }
    function visible(el) { return !!el && el.style.display !== 'none' && getComputedStyle(el).display !== 'none'; }
    function listOf(key) { var dd = root.querySelector('[data-cpg-dd="' + key + '"]'); return dd ? dd.querySelector('.cpg__dd-list') : null; }
    function itemsOf(key) {
      var ul = listOf(key); if (!ul) return [];
      return Array.prototype.map.call(ul.children, function (li, i) {
        if (li.classList.contains('cpg__group')) return { group: true, label: li.textContent, i: i };
        var img = li.querySelector('img.cpg__swatch'), dot = li.querySelector('span.cpg__swatch');
        var spans = li.querySelectorAll('span:not(.cpg__swatch):not(.cpg__code)'), code = li.querySelector('.cpg__code');
        return { i: i, name: spans[0] ? spans[0].textContent : '', code: code ? code.textContent : '',
          img: img ? big(img.getAttribute('src')) : '', bg: dot ? dot.style.background : '', sel: li.classList.contains('is-selected') };
      });
    }
    function selIndex(key) { var it = itemsOf(key).filter(function (x) { return x.sel; })[0]; return it ? it.i : -1; }
    function grouped() { var f = field('mixtoggle'); return !!f && f.style.display !== 'none'; }
    function mixBox() { return root.querySelector('[data-cpg-mix]'); }

    function parts() {
      if (grouped()) return PARTS_GROUPED.filter(function (p) { return listOf(p.key) && itemsOf(p.key).length; });
      return PARTS_SINGLE.filter(function (k) { return visible(field(k)) && itemsOf(k).length; }).map(function (k) {
        var lab = field(k).querySelector('.cpg__label');
        return { key: k, label: lab ? lab.textContent.trim() : k };
      });
    }

    function open(startKey) {
      var ps = parts(); if (!ps.length) return;
      var g = grouped(), mb = mixBox();
      st = { parts: ps, grouped: g, same: g ? !(mb && mb.checked) : false, pick: {}, active: ps[0].key };
      ps.forEach(function (p) { st.pick[p.key] = selIndex(p.key); });
      if (g && st.same) { var f = selIndex('frame'); if (f >= 0) ps.forEach(function (p) { st.pick[p.key] = f; }); }
      if (startKey) {
        var map = { frame: g ? 'mixframe' : 'frame' }, k = map[startKey] || startKey;
        if (ps.some(function (p) { return p.key === k; })) st.active = k;
      }
      render();
      drawer.show();
    }

    function itemAt(key, i) { return itemsOf(key).filter(function (x) { return x.i === i; })[0]; }
    function swatchHTML(it, cls) {
      if (it && it.img) return '<img class="' + cls + '" src="' + it.img + '" alt="" loading="lazy">';
      return '<span class="' + cls + '" style="background:' + ((it && it.bg) || '#ddd') + '"></span>';
    }
    function esc(t) { return String(t || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function escR(t) { return esc(t).replace(/\u00ae/g, '<sup class="cpg-reg">\u00ae</sup>'); }   // ® raised like 3rd

    function render() {
      var h = '<div class="cpg-md__parts" style="--cpg-md-n:' + st.parts.length + '">';
      st.parts.forEach(function (p) {
        var it = itemAt(p.key, st.pick[p.key]), nm = splitName(it ? it.name : '');
        h += '<button type="button" class="cpg-md__part' + (p.key === st.active ? ' is-active' : '') + '" data-part="' + p.key + '">' +
          swatchHTML(it, 'cpg-md__part-img') +
          '<span class="cpg-md__part-label">' + esc(p.label) + '</span>' +
          '<span class="cpg-md__part-name">' + esc(nm[0]) + '</span>' +
          (it ? '<span class="cpg-md__part-mat">' + escR(matLabel(p.key, it.name)) + '</span>' : '') + '</button>';
      });
      h += '</div>';
      var act = st.parts.filter(function (p) { return p.key === st.active; })[0];
      h += '<div class="cpg-md__head"><p class="cpg-md__title">Choose ' + esc(act.label.toLowerCase()) + '</p>';
      if (st.grouped) h += '<label class="cpg-md__same"><input type="checkbox" data-cpg-md-same' + (st.same ? ' checked' : '') + '> <span>Same material on all parts</span></label>';
      h += '</div><div class="cpg-md__grid">';
      itemsOf(st.active).forEach(function (it) {
        if (it.group) { h += '<p class="cpg-md__group">' + esc(it.label) + '</p>'; return; }
        var nm = splitName(it.name);
        h += '<button type="button" class="cpg-md__opt' + (it.i === st.pick[st.active] ? ' is-selected' : '') + '" data-i="' + it.i + '">' +
          swatchHTML(it, 'cpg-md__opt-img') +
          '<span class="cpg-md__opt-name">' + esc(nm[0]) + '</span>' +
          ((matLabel(st.active, it.name) || it.code) ? '<span class="cpg-md__opt-sub">' + escR(matLabel(st.active, it.name) || it.code) + '</span>' : '') + '</button>';
      });
      h += '</div>';
      body.innerHTML = h;
    }

    body.addEventListener('click', function (e) {
      var p = e.target.closest('.cpg-md__part');
      if (p) { st.active = p.getAttribute('data-part'); render(); return; }
      var o = e.target.closest('.cpg-md__opt');
      if (o) {
        var i = +o.getAttribute('data-i');
        if (st.grouped && st.same) st.parts.forEach(function (q) { st.pick[q.key] = i; });
        else st.pick[st.active] = i;
        var sc = drawer.shadowRoot && drawer.shadowRoot.querySelector('[part="body"]'), top = sc ? sc.scrollTop : 0;
        render();
        if (sc) sc.scrollTop = top;
      }
    });
    body.addEventListener('change', function (e) {
      if (e.target.matches('[data-cpg-md-same]')) {
        st.same = e.target.checked;
        if (st.same) { var i = st.pick[st.active]; st.parts.forEach(function (q) { st.pick[q.key] = i; }); render(); }
      }
    });

    function clickItem(key, i) {
      var ul = listOf(key); if (!ul || i < 0) return;
      var li = ul.children[i];
      if (li && !li.classList.contains('is-selected')) li.click();
    }
    applyBtn.addEventListener('click', function () {
      if (!st) return;
      if (st.grouped) {
        var ks = st.parts.map(function (p) { return st.pick[p.key]; });
        var allSame = ks.every(function (k) { return k === ks[0]; });
        var mb = mixBox();
        if (allSame) {
          if (mb && mb.checked) mb.click();
          clickItem('frame', ks[0]);
        } else {
          if (mb && !mb.checked) mb.click();
          st.parts.forEach(function (p) { clickItem(p.key, st.pick[p.key]); });
        }
      } else {
        st.parts.forEach(function (p) { clickItem(p.key, st.pick[p.key]); });
      }
      root.querySelectorAll('.cpg__dd.is-open').forEach(function (x) { x.classList.remove('is-open'); });
      sync();
      drawer.hide();
      // bring the model into view (after the drawer has released the page scroll)
      setTimeout(function () {
        var hd = document.querySelector('.shopify-section--header, header'), off = hd ? Math.max(0, hd.getBoundingClientRect().bottom) : 0;
        var top = root.getBoundingClientRect().top + window.pageYOffset - off;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      }, 350);
    });

    // page summary: the three part fields sit in one row on mobile; the group name hides while parts are mixed
    function sync() {
      var g = grouped(), mb = mixBox();
      root.classList.toggle('cpg--grouped', g);
      root.classList.toggle('cpg--mixed', g && !!(mb && mb.checked));
      pageInfo();
    }
    var busy = false;
    function pageInfo() {
      if (busy) return; busy = true;
      try {
        var t = root.querySelector('.cpg-trio'); if (!t) return;
        // part names without the collection (the grouped Material row keeps it)
        t.querySelectorAll('.cpg__dd-current > span:not(.cpg__swatch):not(.cpg__code)').forEach(function (s) {
          if (/\|\s*(exterior|rattan)\s*$/i.test(s.textContent)) s.textContent = s.textContent.replace(/\s*\|\s*(exterior|rattan)\s*$/i, '');
        });
        var box = root.querySelector('.cpg-pinfo:not(.cpg-apinfo)');
        if (!box) { box = document.createElement('div'); box.className = 'cpg-pinfo'; }
        var anc = root.querySelector('.cpg-choose') || t; if (anc.nextSibling !== box) anc.parentNode.insertBefore(box, anc.nextSibling);
        var fr = itemAt('mixframe', selIndex('mixframe')), wv = itemAt('mixweave', selIndex('mixweave')), pp = itemAt('mixpipe', selIndex('mixpipe'));
        var g = grouped(), frExt = g && fr && isExt(fr.name), afExt = g && ((wv && isExt(wv.name)) || (pp && isExt(pp.name)));
        var h = '';
        if (frExt) h += '<div class="cpg-pinfo__row"><p class="cpg-pinfo__title">Frame \u00b7 ' + escR(matLabel('frame', fr.name)) + '</p><p class="cpg-pinfo__text">' + escR(handpainted(fr.name) ? TXT_FRAME_HP : TXT_FRAME) + '</p></div>';
        if (afExt) h += '<div class="cpg-pinfo__row"><p class="cpg-pinfo__title">Pipe, weave &amp; bindings \u00b7 ArtFibre<sup class="cpg-reg">\u00ae</sup> \u2013 Polyethylene</p><p class="cpg-pinfo__text">' + escR(TXT_AF) + '</p></div>';
        // Originals (rattan) - text from the Rattan 2025 catalogue p.115, Materials & maintenance
        if (g && fr && /\|\s*rattan/i.test(fr.name || '')) h += '<div class="cpg-pinfo__row"><p class="cpg-pinfo__title">Frame, pipe, weave &amp; bindings \u00b7 Rattan</p>' +
          '<p class="cpg-pinfo__text">' + escR('Rattan is a natural material that is solid in opposition to hollow bamboo. Our rattan is of the highest quality, we only use the two sorts Tohiti and Manau. Rattan is nearly impossible to wear out and with proper care it can last for many generations. Rattan is recommended for indoor use and covered areas outdoor. If rattan is exposed to rain, it will turn grey and affect the durability.') + '</p>' +
          '<p class="cpg-pinfo__text">' + escR('Maintenance: Rattan requires no maintenance but can be wiped with a lightly dampened cloth if needed.') + '</p></div>';
        if (box.innerHTML !== h) box.innerHTML = h;
        box.style.display = h ? '' : 'none';
      } finally { busy = false; }
    }
    (function () {
      var mf = field('mixframe'), mp = field('mixpipe'), mw = field('mixweave');
      if (mf && mp && mw && !root.querySelector('.cpg-trio')) {
        var t = document.createElement('div'); t.className = 'cpg-trio';
        mf.parentNode.insertBefore(t, mf); t.appendChild(mf); t.appendChild(mp); t.appendChild(mw);
      }
      root.addEventListener('change', function (e) { if (e.target.matches && e.target.matches('[data-cpg-mix]')) sync(); });
      var tg = field('mixtoggle');
      if (tg && window.MutationObserver) new MutationObserver(sync).observe(tg, { attributes: true, attributeFilter: ['style'] });
      // summary v2: one "Choose materials" button under the three tiles (preview: add cpgv=2 to the link)
      var V2 = !/[?&]cpgv=1\b/.test(location.search) && window.CPG_SUMMARY_V2 !== false;   // on for everyone (17 Oct); ?cpgv=1 shows the old layout
      if (V2) {
        root.classList.add('cpg--v2');
        var t2 = root.querySelector('.cpg-trio');
        if (t2 && !root.querySelector('.cpg-choose')) {
          var cb2 = document.createElement('button'); cb2.type = 'button'; cb2.className = 'button w-full cpg-choose'; cb2.innerHTML = '<div class="text-with-icon">Choose materials</div>';
          cb2.addEventListener('click', function () { open('mixframe'); });
          t2.parentNode.insertBefore(cb2, t2.nextSibling);
        }
      }
      var tr = root.querySelector('.cpg-trio');
      if (tr && window.MutationObserver) new MutationObserver(function () { pageInfo(); }).observe(tr, { childList: true, subtree: true, characterData: true });
      sync();
    })();

    // ---- Related seating under the generator (20 Oct 2026, Dee approved the mock-up).
    // 1) "Explore seating in this configuration": the other seating models of the same collection family (Originals and
    //    Icons share materials, so they count as one), shown as the transparent 3D preview in the current frame colour
    //    (3d_preview_<handle>_<frame slug>.png). Clicking keeps the materials (window.cpgModelLink).
    // 2) "Explore other indoor/outdoor seating": the other collections on the same side (product tag "Indoor"), shown
    //    as each model's standard render (3d_standard_<handle>.png). Indoor and outdoor are never mixed.
    // Missing preview -> standard render -> product photo. Desktop centred, phone left-aligned (CSS).
    var PV = 'v=20261020d';
    function slugOf(s) { return String(s || '').toLowerCase().replace(/\s*\|\s*/g, '-').replace(/&/g, 'and').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
    function famOf(tag) { return /^(originals|icons)$/i.test(tag || '') ? 'originals' : String(tag || '').toLowerCase(); }
    function isSeating(p) { var x = ((p.type || '') + ' ' + (p.title || '')).toLowerCase(); return /chair|stool|sofa|bench|swing/.test(x) && !/foot\s*stool/.test(x); }
    function imgTag(p, first) {
      var std = '/cdn/shop/files/3d_standard_' + p.handle + '.png?width=600&' + PV, photo = p.img || '';
      var src = first || std, chain = first ? [std, photo] : [photo];
      return '<img class="cpg-more__img" alt="' + esc(p.title) + '" loading="lazy" src="' + esc(src) + '" data-fb="' + esc(chain.filter(Boolean).join('|')) + '"' +
        ' onerror="var f=(this.getAttribute(\'data-fb\')||\'\').split(\'|\').filter(Boolean);if(f.length){this.setAttribute(\'data-fb\',f.slice(1).join(\'|\'));this.src=f[0]}else{this.onerror=null}">';
    }
    function cardHtml(p, href, first) {
      return '<a class="cpg-more__card" href="' + esc(href) + '" data-h="' + esc(p.handle) + '"' + (first ? ' data-same' : '') + '>' +
        '<span class="cpg-more__figure">' + imgTag(p, first) + '</span>' +
        '<span class="cpg-more__name">' + esc(p.title) + '</span>' +
        (p.vendor ? '<span class="cpg-more__vendor">' + esc(p.vendor) + '</span>' : '') + '</a>';
    }
    var moreKey = '';
    function moreChairs() {
      var el = document.getElementById('cpg-data-' + sid), data;
      try { data = JSON.parse(el.textContent); } catch (e) { return; }
      var m = typeof window.cpgModels === 'function' ? window.cpgModels() : null;
      var curH = m && m.current, frame = m && m.frame;
      var curP = data.products.filter(function (p) { return p.handle === curH; })[0];
      if (!curP) return;
      var key = curH + '|' + frame; if (key === moreKey) return; moreKey = key;
      var fam = famOf(curP.tag), indoor = !!curP.indoor;
      var same = [], other = [], otherTags = [];
      data.products.forEach(function (p) {
        if (p.handle === curH || !p.glb || !isSeating(p)) return;
        if (famOf(p.tag) === fam) same.push(p);
        else if (!!p.indoor === indoor) { other.push(p); var on = famOf(p.tag) === 'originals' ? 'Originals & Icons' : p.tag; if (otherTags.indexOf(on) < 0) otherTags.push(on); }
      });
      var sec = root.querySelector('.cpg-more');
      if (!sec) {
        sec = document.createElement('section'); sec.className = 'cpg-more'; root.appendChild(sec);
        // same-family cards: build the link at click time, so later material changes are carried over too
        sec.addEventListener('click', function (e) {
          var c = e.target.closest('.cpg-more__card[data-same]');
          if (c && typeof window.cpgModelLink === 'function') c.href = window.cpgModelLink(c.getAttribute('data-h'));
        }, true);
      }
      if (!same.length && !other.length) { sec.style.display = 'none'; sec.innerHTML = ''; return; }
      sec.style.display = '';
      var h = '';
      if (same.length) {
        var famName = fam === 'originals' ? 'Originals &amp; Icons collections' : esc(curP.tag) + ' collection';
        h += '<div class="cpg-more__block"><p class="cpg-more__eyebrow">' + famName + '</p><h2 class="cpg-more__title">Explore seating in this configuration</h2><div class="cpg-more__list">' +
          same.map(function (p) {
            var href = typeof window.cpgModelLink === 'function' ? window.cpgModelLink(p.handle) : location.pathname + '?product=' + encodeURIComponent(p.handle);
            return cardHtml(p, href, '/cdn/shop/files/3d_preview_' + p.handle + '_' + slugOf(frame) + '.png?width=600&' + PV);
          }).join('') + '</div></div>';
      }
      if (other.length) {
        var names = otherTags.map(esc).join(' &amp; ') + (otherTags.length > 1 || /&/.test(otherTags[0]) ? ' collections' : ' collection');
        h += '<div class="cpg-more__block"><p class="cpg-more__eyebrow">' + names + '</p><h2 class="cpg-more__title">Explore other ' + (indoor ? 'indoor' : 'outdoor') + ' seating</h2><div class="cpg-more__list">' +
          other.map(function (p) { return cardHtml(p, location.pathname + '?product=' + encodeURIComponent(p.handle), ''); }).join('') + '</div></div>';
      }
      sec.innerHTML = h;
    }
    (function () {
      moreChairs();
      var t = null, again = function () { clearTimeout(t); t = setTimeout(moreChairs, 250); };
      var pn = root.querySelector('.cpg__panel') || root;
      if (window.MutationObserver) new MutationObserver(again).observe(pn, { childList: true, subtree: true, characterData: true });
    })();

    // material dropdown buttons open the drawer instead of the list (the model dropdown stays a dropdown)
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('.cpg__dd-btn'); if (!btn) return;
      var dd = btn.closest('[data-cpg-dd]'), key = dd && dd.getAttribute('data-cpg-dd');
      if (!key || key === 'product' || dd.classList.contains('is-gen')) return;   // weave-generator rows (Affaire seat/back) open their own weave chooser
      e.preventDefault(); e.stopPropagation();
      open(key);
    }, true);
  }

  function boot() { document.querySelectorAll('x-drawer.cpg-mdrawer').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

/* Material block + Options (18 Oct 2026), DESKTOP ONLY - mobile keeps the tiles, button, info box and cushion block.
   Panel next to the model, like the product page summary: one row per choice, text left-aligned, image on the right.
     Frame color  - compiled image (frame | pipe | weave & bindings); group name, or the three colour names when mixed
     Seat cushion - fabric image (or the None image) and fabric name
   Options section under the configurator, max three columns: Frame (three part images + material info, as on mobile),
   then the fabric (image, composition, info, wash icons, water repellent, Oeko-Tex, as in the fabric drawer).
   ?cpgv=2 = previous layout. */
(function () {
  if (/[?&]cpgv=(1|2)\b/.test(location.search)) return;
  var tries = 0;
  var PARTS = [
    { k: 'mixframe', t: 'Frame', key: 'frame' },
    { k: 'mixpipe', t: 'Pipe', key: 'pipe' },
    { k: 'mixweave', t: 'Weave & bindings', key: 'weave' }
  ];
  var NONE_IMG = '//sika-design.com/cdn/shop/files/None.png?v=1781700131&width=400';
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function bg(u) { return u ? 'url("' + u + '")' : ''; }

  // Frame color image built like the colour pole samples: bindings wrapped across the top, under it a narrow pipe
  // (left) and a wide frame (right) running vertically.
  function loadImg(u) {
    return new Promise(function (res) {
      if (!u) return res(null);
      var im = new Image();
      im.onload = function () { res(im); }; im.onerror = function () { res(null); };
      im.src = u;
    });
  }
  function drawCover(ctx, im, x, y, w, h, rot) {
    if (!im) { ctx.fillStyle = '#ebe7e5'; ctx.fillRect(x, y, w, h); return; }
    ctx.save();
    ctx.beginPath(); ctx.rect(x, y, w, h); ctx.clip();
    ctx.translate(x + w / 2, y + h / 2);
    var bw = w, bh = h;
    if (rot) { ctx.rotate(Math.PI / 2); bw = h; bh = w; }
    var s = Math.max(bw / im.width, bh / im.height), dw = im.width * s, dh = im.height * s;
    ctx.drawImage(im, -dw / 2, -dh / 2, dw, dh);
    ctx.restore();
  }
  function compose(frameSrc, pipeSrc, bindSrc, imgEl) {
    var S = 264, top = Math.round(S * 0.37), pipeW = Math.round(S * 0.22);
    Promise.all([loadImg(frameSrc), loadImg(pipeSrc), loadImg(bindSrc)]).then(function (ims) {
      try {
        var c = document.createElement('canvas'); c.width = c.height = S;
        var ctx = c.getContext('2d');
        drawCover(ctx, ims[1], 0, top, pipeW, S - top, true);          // pipe, vertical
        drawCover(ctx, ims[0], pipeW, top, S - pipeW, S - top, true);  // frame, vertical
        ctx.fillStyle = 'rgba(0,0,0,.18)'; ctx.fillRect(pipeW - 1, top, 2, S - top);   // seam between pipe and frame
        var g = ctx.createLinearGradient(0, top, 0, top + 10);            // shadow under the bindings
        g.addColorStop(0, 'rgba(0,0,0,.22)'); g.addColorStop(1, 'rgba(0,0,0,0)');
        ctx.fillStyle = g; ctx.fillRect(0, top, S, 10);
        drawCover(ctx, ims[2], 0, 0, S, top, true);                     // bindings across the top (wraps run sideways)
        imgEl.src = c.toDataURL('image/jpeg', 0.9);
      } catch (e) { if (frameSrc) imgEl.src = frameSrc; }
    });
  }

  function init() {
    var roots = document.querySelectorAll('.cpg');
    if (!document.querySelector('.cpg .cpg-trio') && roots.length && tries++ < 40) { setTimeout(init, 250); return; }
    roots.forEach(function (root) {
      var trio = root.querySelector('.cpg-trio');
      if (!trio || root.querySelector('.cpg-sum')) return;
      root.classList.add('cpg--v3');
      var frameField = root.querySelector('[data-cpg-field="frame"]');
      var cush = root.querySelector('.cpg-cushion[data-cpg-cushion]');
      var bcush = root.querySelector('.cpg-cushion[data-cpg-bcushion]');   // back cushion (Caroline, 20 Oct 2026)

      // ---- panel rows
      var sum = document.createElement('div');
      sum.className = 'cpg-sum';
      var CHEV = '<svg class="cpg-sum__chev" width="12" height="8" viewBox="0 0 12 8" aria-hidden="true"><path d="M1 1l5 5 5-5" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';
      sum.innerHTML =
        '<div class="cpg-sum__row" role="button" tabindex="0" data-act="mat">' +
          '<span class="cpg__label cpg-sum__label">Frame color</span><span class="cpg-sum__val" data-v="mat"></span>' +
          '<img class="cpg-sum__img" data-i="mat" alt="">' + CHEV +
        '</div>' +
        '<div class="cpg-sum__row" role="button" tabindex="0" data-act="fab" hidden>' +
          '<span class="cpg__label cpg-sum__label">Seat cushion</span><span class="cpg-sum__val" data-v="fab"></span>' +
          '<span class="cpg-sum__add" data-v="fabadd" hidden>Add seat cushion</span>' +
          '<span class="cpg-sum__img" data-i="fab"></span>' + CHEV +
        '</div>' +
        '<div class="cpg-sum__row" role="button" tabindex="0" data-act="bfab" hidden>' +
          '<span class="cpg__label cpg-sum__label">Back cushion</span><span class="cpg-sum__val" data-v="bfab"></span>' +
          '<span class="cpg-sum__add" data-v="bfabadd" hidden>Add back cushion</span>' +
          '<span class="cpg-sum__img" data-i="bfab"></span>' + CHEV +
        '</div>';
      sum.addEventListener('keydown', function (e) { if ((e.key === 'Enter' || e.key === ' ') && e.target.matches('.cpg-sum__row')) { e.preventDefault(); e.target.click(); } });
      (frameField || trio).parentNode.insertBefore(sum, frameField || trio);

      // ---- options section
      var opts = document.createElement('section');
      opts.className = 'cpg-opts';
      opts.innerHTML = '<h2 class="cpg-opts__title">Options</h2><div class="cpg-opts__grid">' +
        '<div class="cpg-opts__col" data-col="mat">' +
          '<h5 class="cpg-opts__head">Frame color</h5>' +
          '<div class="cpg-opts__fbody"><div class="cpg-opts__trio">' + PARTS.map(function (p, i) {
            return '<button type="button" class="cpg-opts__part" data-part="' + i + '"><span class="cpg-opts__pimg"></span>' +
              '<span class="cpg-opts__plabel">' + esc(p.t) + '</span><span class="cpg-opts__pname"></span></button>';
          }).join('') + '</div>' +
          '<h4 class="cpg-opts__ftitle" data-v="mat"></h4>' +
          '<div class="cpg-opts__info" data-v="info"></div></div>' +
          '<button type="button" class="button cpg-opts__btn" data-act="mat">Change frame colors</button>' +
        '</div>' +
        '<div class="cpg-opts__col" data-col="fab" hidden>' +
          '<h5 class="cpg-opts__head">Seat cushion</h5>' +
          '<div class="cpg-opts__fab"></div>' +
          '<div class="cpg-opts__btnrow"><button type="button" class="button cpg-opts__btn" data-act="fab" data-v="fabbtn">Change fabric</button>' +
          '<button type="button" class="button cpg-opts__btn cpg-opts__btn--line" data-act="badd" data-v="baddbtn" hidden>Add back cushion</button>' +
          '<button type="button" class="cpg-opts__link" data-act="rm" data-v="rmlink" hidden>Remove cushion</button></div>' +
        '</div>' +
        '<div class="cpg-opts__col" data-col="bfab" hidden>' +
          '<h5 class="cpg-opts__head">Back cushion</h5>' +
          '<div class="cpg-opts__fab"></div>' +
          '<div class="cpg-opts__btnrow"><button type="button" class="button cpg-opts__btn" data-act="bfab">Change fabric</button>' +
          '<button type="button" class="cpg-opts__link" data-act="brm">Remove back cushion</button></div>' +
        '</div>' +
      '</div>';
      var more = root.querySelector('.cpg-more');
      if (more) root.insertBefore(opts, more); else root.appendChild(opts);

      function openMat(part) {
        var b = root.querySelector('.cpg-choose'); if (!b) return;
        b.click();
        if (part != null) setTimeout(function () { var pb = document.querySelectorAll('.cpg-md__part')[part]; if (pb) pb.click(); }, 80);
      }
      function openFab() { var b = cush && cush.querySelector('[data-cpg-cushion-open]'); if (b) b.click(); }
      function removeFab() { var b = cush && cush.querySelector('[data-cpg-cushion-remove]'); if (b) b.click(); }
      function openBFab() { var b = bcush && bcush.querySelector('[data-cpg-cushion-open]'); if (b) b.click(); }
      function removeBFab() { var b = bcush && bcush.querySelector('[data-cpg-cushion-remove]'); if (b) b.click(); }
      function onClick(e) {
        var t = e.target.closest('[data-act], [data-part]'); if (!t) return;
        if (t.hasAttribute('data-part')) return openMat(+t.getAttribute('data-part'));
        var a = t.getAttribute('data-act');
        if (a === 'mat') openMat(); else if (a === 'fab') openFab(); else if (a === 'rm') removeFab();
        else if (a === 'bfab' || a === 'badd') openBFab(); else if (a === 'brm') removeBFab();
      }
      sum.addEventListener('click', onClick);
      opts.addEventListener('click', onClick);

      // fabric data from the cushion fabric drawer (same source as the drawer itself)
      function fabricFor(code) {
        var el = document.querySelector('.cpg-cdrawer cushion-color-drawer, cushion-color-drawer.cpg-fabric-drawer');
        if (!el || !code) return null;
        var data = el.fabricsData || {}, title = null;
        Object.keys(data).some(function (k) { if (k.split('|')[0].trim().toUpperCase() === code.toUpperCase()) { title = k; return true; } return false; });
        if (!title) return null;
        var tpl = null;
        el.querySelectorAll('.js-fabric-data-templates > [data-fabric-title]').forEach(function (d) { if (d.getAttribute('data-fabric-title') === title) tpl = d; });
        function part(sel) { var x = tpl && tpl.querySelector(sel); return x ? x.innerHTML : ''; }
        var wr = el.querySelector('.js-selected-water-repellent'), ot = el.querySelector('.js-selected-oeka');
        return {
          title: title, img: data[title].img,
          main: part('.tpl-main-info'), info: part('.tpl-info'), wash: part('.tpl-wash'),
          wr: data[title].water_repellent ? (wr ? wr.innerHTML : '') : '',
          ot: data[title].oeko_tex ? (ot ? ot.innerHTML : '') : ''
        };
      }

      // material info rows from the (hidden on desktop) info box
      function infoHtml() {
        var pbox = root.querySelector('.cpg-pinfo:not(.cpg-apinfo)'), h = '';   // only the page's own info box (not the hidden Affaire/Alu box or the drawer's care text)
        var rows = pbox ? pbox.querySelectorAll('.cpg-pinfo__row') : [];
        rows.forEach(function (r) {
          var tt = r.querySelector('.cpg-pinfo__title'), txs = r.querySelectorAll('.cpg-pinfo__text');
          h += '<div class="cpg-opts__irow"><p class="cpg-opts__ititle">' + (tt ? tt.innerHTML : '') + '</p>' +
               Array.prototype.map.call(txs, function (tx) { return '<p class="cpg-opts__itext">' + tx.innerHTML + '</p>'; }).join('') + '</div>';
        });
        return h;
      }

      var queued = false, lastFab = null, lastBFab = null, lastComp = null;
      // one cushion block (seat or back) -> what the panel and Options show
      function fabState(blk) {
        var nameEl = blk.querySelector('[data-cpg-cushion-name]'), subEl = blk.querySelector('[data-cpg-cushion-sub]');
        var rm = blk.querySelector('[data-cpg-cushion-remove]');
        var on = blk.hasAttribute('data-on') ? blk.getAttribute('data-on') === '1' : !!(rm && !rm.hidden);
        var nm0 = nameEl ? nameEl.textContent.split('|')[0].trim() : '';
        var code = on ? (/^[A-Z]{1,3}\d{2,4}[A-Z]?$/.test(nm0) ? nm0 : (subEl ? subEl.textContent.trim() : '')) : '';
        var fab = on ? fabricFor(code) : null, cImg = blk.querySelector('[data-cpg-cushion-img]');
        var img = on ? ((fab && fab.img) || (cImg && cImg.style.backgroundImage.replace(/^url\(["']?|["']?\)$/g, ''))) : NONE_IMG;
        var name = nameEl ? nameEl.textContent : '';
        return { on: on, code: code, fab: fab, img: img, name: name, key: on ? code + '|' + name : 'none',
          title: on ? (fab ? fab.title : (name + (code ? ' | ' + code : ''))) : 'None', included: blk.hasAttribute('data-included') };
      }
      function fabBox(s) {
        var fab = s.fab;
        return '<span class="cpg-opts__fimg2" style="background-image:' + esc(bg(s.img)) + '"></span>' +
          '<span class="cpg-opts__plabel">Fabric</span>' +
          '<h4 class="cpg-opts__ftitle">' + esc(fab ? fab.title : s.name) + '</h4>' +
          '<div class="cpg-opts__fgrid"><div class="cpg-opts__fleft">' +
            (fab && fab.main ? '<div class="cpg-opts__fmain">' + fab.main + '</div>' : '') +
            (fab && fab.info ? '<div class="cpg-opts__ftext">' + fab.info + '</div>' : '') +
            (fab && fab.wash ? '<div class="cpg-opts__wash">' + fab.wash + '</div>' : '') +
          '</div>' +
          (fab && (fab.wr || fab.ot) ? '<div class="cpg-opts__badges">' + (fab.wr ? '<span>' + fab.wr + '</span>' : '') + (fab.ot ? '<span>' + fab.ot + '</span>' : '') + '</div>' : '') +
          '</div>';
      }
      function updateBack(hasCush) {
        var hasB = !!(hasCush && bcush && !bcush.hidden);
        var bRow = sum.querySelector('[data-act="bfab"]'), bCol = opts.querySelector('[data-col="bfab"]'), add = opts.querySelector('[data-v="baddbtn"]');
        var s = hasB ? fabState(bcush) : { on: false, key: 'none' };
        bRow.hidden = !hasB;
        bCol.hidden = !(hasB && s.on);
        add.hidden = !(hasB && !s.on);
        add.parentNode.classList.toggle('has-add', !add.hidden);
        opts.classList.toggle('cpg-opts--back', !bCol.hidden);
        if (!hasB) return;
        var bi = sum.querySelector('[data-i="bfab"]');
        bi.style.backgroundImage = bg(s.img); bi.classList.toggle('is-none', !s.on);
        sum.querySelector('[data-v="bfab"]').textContent = s.title;
        sum.querySelector('[data-v="bfabadd"]').hidden = s.on;
        if (s.key === lastBFab) return;
        lastBFab = s.key;
        bCol.querySelector('.cpg-opts__fab').innerHTML = s.on ? fabBox(s) : '';
      }
      function update() {
        queued = false;
        // frame
        var parts = PARTS.map(function (p) {
          var f = trio.querySelector('[data-cpg-field="' + p.k + '"]');
          var img = f && f.querySelector('.cpg__dd-current .cpg__swatch');
          var nm = f && f.querySelector('.cpg__dd-current > span:not(.cpg__swatch):not(.cpg__code)');
          return {
            src: img ? (img.getAttribute('src') || '').replace(/([?&]width=)\d+/, '$1400') : '',
            name: nm ? nm.textContent.replace(/\s*\|\s*(exterior|rattan)\s*$/i, '').trim() : ''
          };
        });
        var same = parts[0].name && parts.every(function (p) { return p.name === parts[0].name; });
        var gName = frameField && frameField.querySelector('.cpg__dd-current > span:not(.cpg__swatch):not(.cpg__code)');
        var matName = same ? ((gName && gName.textContent.trim()) || parts[0].name) : parts.map(function (p) { return p.name; }).join(' / ');
        root.querySelectorAll('.cpg-sum [data-v="mat"], .cpg-opts [data-v="mat"]').forEach(function (x) { x.textContent = matName; });
        var ck = parts.map(function (p) { return p.src; }).join('|');
        if (ck !== lastComp) { lastComp = ck; compose(parts[0].src, parts[1].src, parts[2].src, sum.querySelector('[data-i="mat"]')); }
        opts.querySelectorAll('.cpg-opts__part').forEach(function (b, i) {
          b.querySelector('.cpg-opts__pimg').style.backgroundImage = bg(parts[i].src);
          b.querySelector('.cpg-opts__pname').textContent = parts[i].name;
        });
        var info = opts.querySelector('[data-v="info"]'), ih = infoHtml();
        if (info.innerHTML !== ih) info.innerHTML = ih;
        info.hidden = !ih;

        // seat cushion (only when the model has one)
        var hasCush = !!(cush && !cush.hidden && cush.style.display !== 'none');
        var fRow = sum.querySelector('[data-act="fab"]'), fCol = opts.querySelector('[data-col="fab"]');
        fRow.hidden = fCol.hidden = !hasCush;
        opts.classList.toggle('cpg-opts--one', !hasCush);
        updateBack(hasCush);
        if (!hasCush) return;
        var s = fabState(cush), on = s.on;
        var fi = sum.querySelector('[data-i="fab"]');
        fi.style.backgroundImage = bg(s.img); fi.classList.toggle('is-none', !on);
        sum.querySelector('[data-v="fab"]').textContent = s.title;
        var fb = opts.querySelector('[data-v="fabbtn"]'); if (fb) fb.textContent = on ? 'Change fabric' : 'Add seat cushion';
        var rl = opts.querySelector('[data-v="rmlink"]'); if (rl) rl.hidden = !on || s.included;
        var fa = sum.querySelector('[data-v="fabadd"]'); if (fa) fa.hidden = on;
        fCol.classList.toggle('is-empty', !on);   // no cushion: only the heading and the Add seat cushion button
        if (s.key === lastFab) return;
        lastFab = s.key;
        opts.querySelector('[data-col="fab"] .cpg-opts__fab').innerHTML = on ? fabBox(s) : '';
      }
      function queue() { if (!queued) { queued = true; requestAnimationFrame(update); } }
      update();
      if (window.MutationObserver) {
        var mo = new MutationObserver(queue);
        mo.observe(trio, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['src'] });
        if (frameField) mo.observe(frameField, { childList: true, subtree: true, characterData: true });
        if (trio.parentNode) mo.observe(trio.parentNode, { childList: true });
        var pi = root.querySelector('.cpg-pinfo:not(.cpg-apinfo)'); if (pi) mo.observe(pi, { childList: true, subtree: true, characterData: true });
        if (cush) mo.observe(cush, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['hidden', 'style', 'class', 'data-on'] });
        if (bcush) mo.observe(bcush, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['hidden', 'style', 'class', 'data-on'] });
      }
      setTimeout(queue, 1500);   // fabric drawer data may connect after us

      // Desktop: ONLY when there are three option rows (frame + two cushions) let the top section grow, so the
      // bottom-anchored panel clears the title. With one or two options the section keeps its normal height.
      var DESK = window.matchMedia('(min-width: 1200px), (min-width: 768px) and (orientation: landscape)');
      function fitPanel() {
        var viewer = root.querySelector('.cpg__viewer'), grid = root.querySelector('.cpg__grid');
        var panel = root.querySelector('.cpg__panel'), head = root.querySelector('.cpg__stagehead');
        if (!viewer || !grid || !panel || !head) return;
        // counts the visible rows of either summary (the Alu Affäire one too)
        var rows = Array.prototype.filter.call(root.querySelectorAll('.cpg-sum .cpg-sum__row, .cpg-asum .cpg-sum__row'), function (r) { return !r.hidden && r.offsetParent !== null; }).length;
        var three = DESK.matches && rows >= 3;
        root.classList.toggle('cpg--three', three);
        viewer.style.minHeight = '';
        if (!three) return;
        var g = grid.getBoundingClientRect(), hb = head.getBoundingClientRect();
        var need = Math.ceil((hb.bottom - g.top) + 28 + panel.getBoundingClientRect().height);
        if (need > g.height) viewer.style.minHeight = need + 'px';
      }
      var fitQ = false;
      function fitSoon() { if (!fitQ) { fitQ = true; requestAnimationFrame(function () { fitQ = false; fitPanel(); }); } }
      if (window.MutationObserver) new MutationObserver(fitSoon).observe(sum, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
      window.addEventListener('resize', fitSoon);
      fitSoon();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 0); });
  else setTimeout(init, 0);
})();

/* Dimensions & downloads (18 Oct 2026). Desktop: collapsed section under Options, like the DIMENSIONS toggle on the
   product page. Phone: the product page's mobile DIMENSIONS accordion, under the Request button. Both blocks and their
   styles are taken from the model's own product page, so they always show the same data as the product page. */
(function () {
  if (/[?&]cpgv=(1|2)\b/.test(location.search)) return;
  var cssReady = null, cache = {}, tries = 0;
  var LABEL = 'DIMENSIONS & DOWNLOADS';
  function dataProducts() {
    var s = document.querySelector('script[id^="cpg-data-"]');
    try { return (JSON.parse(s.textContent).products) || []; } catch (e) { return []; }
  }
  function currentHandle(root) {
    var h = (location.search.match(/[?&]product=([^&#]+)/) || [])[1];
    var t = root.querySelector('.cpg__stagehead h1, .cpg__stagehead h2, .cpg__stagehead [class*="title"]');
    var title = t ? t.textContent.trim().toLowerCase() : '';
    var list = dataProducts();
    if (title) for (var i = 0; i < list.length; i++) if ((list[i].title || '').trim().toLowerCase() === title) return list[i].handle;
    return h ? decodeURIComponent(h) : '';
  }
  function keepRules(rules, out) {
    for (var i = 0; i < rules.length; i++) {
      var r = rules[i];
      if (r.media && r.cssRules) { var inner = []; keepRules(r.cssRules, inner); if (inner.length) out.push('@media ' + r.media.mediaText + '{' + inner.join('') + '}'); }
      else if (r.selectorText && /dimensions-|workfiles/.test(r.selectorText)) out.push(r.cssText);
    }
  }
  function addCss(doc) {
    if (cssReady) return cssReady;
    var urls = [].slice.call(doc.querySelectorAll('link[rel="stylesheet"][href*="main-product-style.css"], link[rel="stylesheet"][href*="dimensions.css"]'))
      .map(function (l) { return l.getAttribute('href'); })
      .filter(function (u, i, a) { return a.indexOf(u) === i; });
    cssReady = Promise.all(urls.map(function (u) {
      return fetch(u).then(function (r) { return r.text(); }).then(function (txt) {
        var out = [];
        try { var sh = new CSSStyleSheet(); sh.replaceSync(txt.replace(/@import[^;]+;/g, '')); keepRules(sh.cssRules, out); } catch (e) { return; }
        var st = document.createElement('style'); st.setAttribute('data-cpg-dim', u.split('/').pop().split('?')[0]);
        st.textContent = out.join('\n'); document.head.appendChild(st);
      }).catch(function () {});
    }));
    return cssReady;
  }
  // the block's own inline style, re-scoped from the product page section id to our wrapper; only rules that were
  // scoped to that section (or to the dimensions block itself) are kept, so nothing leaks into the rest of the page
  function scoped(text, sid, scope) {
    if (!text || !sid) return '';
    var out = [];
    function walk(rules) {
      var res = [];
      for (var i = 0; i < rules.length; i++) {
        var r = rules[i];
        if (r.media && r.cssRules) { var inner = walk(r.cssRules); if (inner.length) res.push('@media ' + r.media.mediaText + '{' + inner.join('') + '}'); }
        else if (r.selectorText && (r.selectorText.indexOf('#' + sid) > -1 || /dimensions-|workfiles/.test(r.selectorText))) res.push(r.cssText.split('#' + sid).join(scope));
      }
      return res;
    }
    try { var sh = new CSSStyleSheet(); sh.replaceSync(text.replace(/@import[^;]+;/g, '')); out = walk(sh.cssRules); } catch (e) { return ''; }
    return out.join('\n');
  }
  function styleBefore(el, scope) {
    var sec = el.closest('.shopify-section'), txt = '';
    var st = el.previousElementSibling;
    if (st && st.tagName === 'STYLE') txt = st.textContent;
    else if (sec) [].forEach.call(sec.querySelectorAll(':scope > style'), function (s) { txt += s.textContent; });
    return sec ? scoped(txt, sec.id, scope) : '';
  }
  function links(el) { [].forEach.call(el.querySelectorAll('a[href^="http"]'), function (a) { a.target = '_blank'; a.rel = 'noopener'; }); }
  function load(handle) {
    if (!cache[handle]) cache[handle] = fetch('/products/' + encodeURIComponent(handle)).then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return null;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var desk = doc.querySelector('.js-dimensions-block') || doc.querySelector('.dimensions-pdp_block_wrapper');
        var mob = null;
        [].some.call(doc.querySelectorAll('.shopify-section'), function (s) {
          if (!/__dimensions/.test(s.id)) return false;
          mob = s.querySelector('.dimensions-section'); return !!mob;
        });
        if (!desk && !mob) return null;
        var ready = addCss(doc);
        var d = {};
        if (desk) { d.dStyle = styleBefore(desk, '.cpg-dim__desk'); desk.classList.remove('hide'); links(desk); d.desk = desk.outerHTML; }
        if (mob) {
          d.mStyle = styleBefore(mob, '.cpg-dim__mob');
          var t = mob.querySelector('.dimensions-section__mobile-accordion-title'); if (t) t.textContent = LABEL;
          links(mob); d.mob = mob.outerHTML;
        }
        return ready.then(function () { return d; });   // show only once the styles are in (no flash of the open block)
      }).catch(function () { return null; });
    return cache[handle];
  }
  function init() {
    var root = document.querySelector('.cpg.cpg--v3'), opts = root && root.querySelector('.cpg-opts');
    if (!opts) { if (tries++ < 40) setTimeout(init, 250); return; }
    if (root.querySelector('.cpg-dim')) return;
    var sec = document.createElement('section');
    sec.className = 'cpg-dim'; sec.hidden = true;
    sec.innerHTML = '<div class="cpg-dim__desk"><button type="button" class="cpg-dim__toggle" aria-expanded="false" aria-controls="cpg-dim-body">' +
      '<span class="cpg-dim__title">Dimensions &amp; downloads</span>' +
      '<svg class="cpg-dim__chev" width="16" height="10" viewBox="0 0 16 10" aria-hidden="true"><path d="M1 1.5l7 7 7-7" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>' +
      '</button><div class="cpg-dim__body" id="cpg-dim-body" hidden></div></div><div class="cpg-dim__mob"></div>';
    opts.parentNode.insertBefore(sec, opts.nextSibling);
    // phone: the accordion sits in the panel, right above the Request button
    var mEl = sec.querySelector('.cpg-dim__mob'), req = root.querySelector('.cpg__request');
    if (mEl) { mEl.hidden = true; if (req) req.parentNode.insertBefore(mEl, req); }
    var btn = sec.querySelector('.cpg-dim__toggle'), body = sec.querySelector('.cpg-dim__body'), mbox = mEl;
    btn.addEventListener('click', function () {
      var open = body.hidden; body.hidden = !open; btn.setAttribute('aria-expanded', String(open));
    });
    // phone accordion: same behaviour as on the product page (aria-expanded + is-active on the toggle)
    mbox.addEventListener('click', function (e) {
      var tg = e.target.closest('.dimensions-section__mobile-accordion-toggle'); if (!tg) return;
      var open = tg.getAttribute('aria-expanded') !== 'true';
      tg.setAttribute('aria-expanded', String(open)); tg.classList.toggle('is-active', open);
    });
    var shown = '';
    function refresh() {
      var h = currentHandle(root);
      if (!h || h === shown) return;
      shown = h;
      load(h).then(function (d) {
        if (shown !== h) return;
        if (!d) { sec.hidden = true; mbox.hidden = true; body.innerHTML = ''; mbox.innerHTML = ''; return; }
        body.innerHTML = d.desk ? ((d.dStyle ? '<style>' + d.dStyle + '</style>' : '') + d.desk) : '';
        mbox.innerHTML = d.mob ? ((d.mStyle ? '<style>' + d.mStyle + '</style>' : '') + d.mob) : '';
        sec.classList.toggle('has-desk', !!d.desk); sec.classList.toggle('has-mob', !!d.mob);
        sec.hidden = false; mbox.hidden = !d.mob;
      });
    }
    refresh();
    var head = root.querySelector('.cpg__stagehead');
    if (head && window.MutationObserver) new MutationObserver(function () { setTimeout(refresh, 50); }).observe(head, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 300); });
  else setTimeout(init, 300);
})();


/* Alu Affäire materials (19 Oct 2026). Frame (powder-coated aluminium), Pipe (ArtFibre in the frame colours) and Weave;
   the bindings follow the weave (section code). Desktop: summary rows next to the model + an Options section;
   phone: tiles, Choose materials, Materials & care - like Exterior. The drawer shows Frame / Pipe / Weave tiles;
   Weave opens the original weave drawer next to it on desktop (the material drawer shrinks by a third and keeps
   Frame + Pipe), or over it on a phone (back arrow top right, See my model at the bottom).
   Everything is driven through the section's own dropdowns and weave drawer, so the selection logic stays there. */
(function () {
  var TXT_FRAME = 'Hand-bent aluminum frame, powder coated for a smooth finish. Well-suited to be left outside all year long, easy to clean and maintenance free.';
  var TXT_AF = 'ArtFibre® is made of dyed, hard-wearing polyethylene that is temperature and UV-resistant, making it ideal for outdoor use in any climate. It is flexible, comfortable when woven and keeps its shape for years.';
  // Affaire (19 Oct 2026): one material - Natural Skin-on rattan frame and pipe, ArtFibre weave and bindings (texts from the Isabell product page)
  var TXT_SKIN = 'Rattan is often confused with bamboo, but unlike hollow bamboo, rattan is solid and can be bent into all sorts of shapes, which makes rattan furniture very durable and able to last for generations. Because of the rattan frame, the furniture must be kept dry and can only be used outdoors in covered areas.';
  var TXT_AF_IN = 'ArtFibre® is a unique fibre made of dyed, hard-wearing polyethylene that is temperature and UV-resistant. It has a strong structure, keeps its shape for years and is very flexible, so it is comfortable when woven. Rattan and ArtFibre® need no maintenance but can be wiped with a lightly dampened cloth.';
  var DESK = window.matchMedia('(min-width: 1200px), (min-width: 768px) and (orientation: landscape)');
  var CHEV = '<svg class="cpg-sum__chev" width="12" height="8" viewBox="0 0 12 8" aria-hidden="true"><path d="M1 1l5 5 5-5" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function escR(t) { return esc(t).replace(/®/g, '<sup class="cpg-reg">®</sup>'); }
  function big(src) {
    if (!src) return src;
    return /[?&]width=\d+/.test(src) ? src.replace(/([?&])width=\d+/, '$1width=600') : src + (src.indexOf('?') < 0 ? '?' : '&') + 'width=600';
  }
  function first(n) { var i = (n || '').indexOf('|'); return (i < 0 ? n || '' : n.slice(0, i)).trim(); }
  function careHtml(cls, aff) {
    cls = cls || 'cpg-pinfo';
    if (aff) return '<div class="' + cls + '__row"><p class="' + cls + '__title">Frame &amp; pipe · Skin-on Rattan</p><p class="' + cls + '__text">' + escR(TXT_SKIN) + '</p></div>' +
      '<div class="' + cls + '__row"><p class="' + cls + '__title">Weave &amp; bindings · ArtFibre<sup class="cpg-reg">®</sup> – Polyethylene</p><p class="' + cls + '__text">' + escR(TXT_AF_IN) + '</p></div>';
    return '<div class="' + cls + '__row"><p class="' + cls + '__title">Frame · Powdercoated Aluminum</p><p class="' + cls + '__text">' + escR(TXT_FRAME) + '</p></div>' +
      '<div class="' + cls + '__row"><p class="' + cls + '__title">Pipe, weave &amp; bindings · ArtFibre<sup class="cpg-reg">®</sup> – Polyethylene</p><p class="' + cls + '__text">' + escR(TXT_AF) + '</p></div>';
  }

  function init(root) {
    if (root.__aluInit) return;
    var sid = root.id.replace(/^cpg-/, '');
    var drawer = document.getElementById('cpg-mdrawer-' + sid);
    var modal = root.querySelector('[data-cpg-modal]');
    if (!drawer || !modal) return;
    root.__aluInit = true;
    var body = drawer.querySelector('[data-cpg-md-body]'), applyBtn = drawer.querySelector('[data-cpg-md-apply]');
    var st = null;
    function on() { return root.classList.contains('cpg--alu'); }
    // Affaire: the section sets cpg--alu (shared layout) + cpg--aff; no frame/pipe choice, so only the weave drawer opens
    function aff() { return root.classList.contains('cpg--aff'); }
    function listOf(key) { var dd = root.querySelector('[data-cpg-dd="' + key + '"]'); return dd ? dd.querySelector('.cpg__dd-list') : null; }
    function itemsOf(key) {
      var ul = listOf(key); if (!ul) return [];
      return Array.prototype.map.call(ul.children, function (li, i) {
        var img = li.querySelector('img.cpg__swatch'), dot = li.querySelector('span.cpg__swatch');
        var sp = li.querySelector('span:not(.cpg__swatch):not(.cpg__code)');
        return { i: i, name: sp ? sp.textContent : '', img: img ? big(img.getAttribute('src')) : '', bg: dot ? dot.style.background : '', sel: li.classList.contains('is-selected') };
      });
    }
    function selIndex(key) { var it = itemsOf(key).filter(function (x) { return x.sel; })[0]; return it ? it.i : 0; }
    function itemAt(key, i) { return itemsOf(key)[i] || null; }
    function weave() {
      var cur = root.querySelector('[data-cpg-dd="seat"] .cpg__dd-current');
      var sw = cur && cur.querySelector('.cpg__swatch--weave');
      var m = sw && /url\(["']?([^"')]+)/.exec(sw.style.background || sw.style.backgroundImage || '');
      var nm = cur && cur.querySelector('.cpg__val-name'), cols = cur && cur.querySelector('.cpg__val-cols');
      return { img: m ? m[1] : '', bg: sw && !m ? sw.style.background : '', name: nm ? nm.textContent.replace(/\s*weave\s*$/i, '') : '', cols: cols ? cols.textContent : '' };
    }
    function imgStyle(o) { return o && o.img ? 'background-image:url("' + String(o.img).replace(/"/g, '%22') + '")' : (o && o.bg ? 'background:' + o.bg : ''); }
    function tileImg(o, cls) {
      if (o && o.img) return '<img class="' + cls + '" src="' + esc(o.img) + '" alt="" loading="lazy">';
      return '<span class="' + cls + '" style="background:' + esc((o && o.bg) || '#ddd') + '"></span>';
    }

    // ---------------- drawer
    function partsData(pick) {
      var f = itemAt('frame', pick ? pick.frame : selIndex('frame')), p = itemAt('pipe', pick ? pick.pipe : selIndex('pipe')), w = weave();
      return [
        { k: 'frame', t: 'Frame', o: f, name: first(f && f.name), sub: aff() ? 'Skin-on Rattan' : 'Powdercoated Aluminum' },
        { k: 'pipe', t: 'Pipe', o: p, name: first(p && p.name), sub: aff() ? 'Skin-on Rattan' : 'ArtFibre®' },
        { k: 'weave', t: 'Weave', o: w, name: w.name, sub: w.cols }
      ];
    }
    function render() {
      var split = st.active === 'weave' && DESK.matches;
      var ps = partsData(st.pick);
      if (split) ps = ps.slice(0, 2);
      var h = '<div class="cpg-md__parts cpg-ad__parts" style="--cpg-md-n:' + ps.length + '">';
      ps.forEach(function (p) {
        h += '<button type="button" class="cpg-md__part cpg-ad__part' + (p.k === st.active ? ' is-active' : '') + '" data-ad-part="' + p.k + '">' +
          tileImg(p.o, 'cpg-md__part-img') +
          '<span class="cpg-md__part-label">' + esc(p.t) + '</span>' +
          '<span class="cpg-md__part-name">' + esc(p.name) + '</span>' +
          (p.sub ? '<span class="cpg-md__part-mat">' + escR(p.sub) + '</span>' : '') + '</button>';
      });
      h += '</div>';
      if (st.active === 'frame' || st.active === 'pipe') {
        h += '<div class="cpg-md__head"><p class="cpg-md__title">Choose ' + st.active + '</p>' +
          '<label class="cpg-md__same"><input type="checkbox" data-ad-same' + (st.follow ? ' checked' : '') + '> <span>Same color on frame and pipe</span></label></div><div class="cpg-md__grid">';
        itemsOf(st.active).forEach(function (it) {
          h += '<button type="button" class="cpg-md__opt' + (it.i === st.pick[st.active] ? ' is-selected' : '') + '" data-ad-i="' + it.i + '">' +
            tileImg(it, 'cpg-md__opt-img') +
            '<span class="cpg-md__opt-name">' + esc(first(it.name)) + '</span>' +
            '<span class="cpg-md__opt-sub">' + escR(st.active === 'frame' ? 'Powdercoated Aluminum' : 'ArtFibre®') + '</span></button>';
        });
        h += '</div>';
      }
      h += '<div class="cpg-ad__care"><p class="cpg-md__title">Materials &amp; care</p><div class="cpg-pinfo">' + careHtml(null, aff()) + '</div></div>';
      body.innerHTML = h;
    }
    // the weave drawer sits outside the material drawer: clicks in it (or the hidden seat row that opens it)
    // must not count as "click outside" and close the material drawer
    if (!drawer.__adHide) {
      drawer.__adHide = drawer.hide;
      drawer.hide = function () {
        var ev = window.event, t = ev && ev.target;
        if (on() && t && t.nodeType === 1 && (modal.contains(t) || t.closest('[data-cpg-dd]'))) return;
        return drawer.__adHide.apply(this, arguments);
      };
    }
    // touch screens: the drawer's focus trap blocks taps (and scrolling) outside the drawer unless they are allowed here,
    // so the weave drawer on a phone would not react at all
    if (!drawer.__adAllow) {
      drawer.__adAllow = true;
      var inWeave = function (t) { return on() && t && t.nodeType === 1 && (modal.contains(t) || !!t.closest('[data-cpg-dd]')); };
      var aofc = drawer.allowOutsideClickForTarget, hofc = drawer.hideForOutsideClickTarget;
      drawer.allowOutsideClickForTarget = function (t) { return inWeave(t) || (aofc ? aofc.call(this, t) : false); };
      drawer.hideForOutsideClickTarget = function (t) { return inWeave(t) ? false : (hofc ? hofc.call(this, t) : false); };
    }
    function openWeave() {
      if (DESK.matches && !aff()) drawer.classList.add('cpg-ad--split');
      var b = root.querySelector('[data-cpg-dd="seat"] .cpg__dd-btn');
      if (b) b.click();
    }
    function closeWeave() {
      drawer.classList.remove('cpg-ad--split');
      if (on()) modal.hidden = true;
    }
    function open(startKey) {
      if (aff()) { st = null; setTimeout(openWeave, 0); return; }   // Affaire: the weave drawer on its own
      st = { active: startKey || 'frame', pick: { frame: selIndex('frame'), pipe: selIndex('pipe') } };
      st.follow = st.pick.pipe === st.pick.frame;
      if (st.active !== 'weave') closeWeave();
      render();
      drawer.show();
      if (st.active === 'weave') setTimeout(openWeave, 30);
    }
    function clickItem(key, i) {
      var ul = listOf(key); if (!ul || i < 0) return;
      var li = ul.children[i];
      if (li && !li.classList.contains('is-selected')) li.click();
    }
    function apply() {
      if (st) {
        clickItem('frame', st.pick.frame);
        clickItem('pipe', st.pick.pipe);
      }
      root.querySelectorAll('.cpg__dd.is-open').forEach(function (x) { x.classList.remove('is-open'); });
      closeWeave();
      // the original hide: the guarded one ignores calls made from a tap in the weave drawer (See my model on a phone)
      if (drawer.hasAttribute('open')) (drawer.__adHide || drawer.hide).call(drawer);
      setTimeout(function () {
        var hd = document.querySelector('.shopify-section--header, header'), off = hd ? Math.max(0, hd.getBoundingClientRect().bottom) : 0;
        window.scrollTo({ top: Math.max(0, root.getBoundingClientRect().top + window.pageYOffset - off), behavior: 'smooth' });
      }, 350);
    }
    // capture: our markup only, and the generic drawer handlers never see these clicks
    body.addEventListener('click', function (e) {
      if (!on() || !st) return;
      var p = e.target.closest('[data-ad-part]'), o = e.target.closest('[data-ad-i]');
      if (!p && !o) return;
      e.stopPropagation();
      if (p) {
        var k = p.getAttribute('data-ad-part');
        st.active = k;
        if (k === 'weave') { render(); openWeave(); }
        else { closeWeave(); render(); }
        return;
      }
      var i = +o.getAttribute('data-ad-i');
      // ticked "Same color on frame and pipe": one pick colours both; unticked: each part on its own (like Exterior)
      if (st.follow) { st.pick.frame = i; st.pick.pipe = i; }
      else st.pick[st.active] = i;
      var sc = drawer.shadowRoot && drawer.shadowRoot.querySelector('[part="body"]'), top = sc ? sc.scrollTop : 0;
      render();
      if (sc) sc.scrollTop = top;
    }, true);
    body.addEventListener('change', function (e) {
      if (!on() || !st || !e.target.matches || !e.target.matches('[data-ad-same]')) return;
      e.stopPropagation();
      st.follow = e.target.checked;
      if (st.follow) { var k = st.active === 'pipe' ? 'pipe' : 'frame'; st.pick.frame = st.pick.pipe = st.pick[k]; }
      var sc = drawer.shadowRoot && drawer.shadowRoot.querySelector('[part="body"]'), top = sc ? sc.scrollTop : 0;
      render();
      if (sc) sc.scrollTop = top;
    }, true);
    drawer.addEventListener('click', function (e) {
      if (!on() || !e.target.closest('[data-cpg-md-apply]')) return;
      e.stopPropagation(); e.preventDefault();
      apply();
    }, true);
    // drawer closed (arrow, overlay, Esc): the weave drawer goes with it
    new MutationObserver(function () { if (!drawer.hasAttribute('open')) closeWeave(); }).observe(drawer, { attributes: true, attributeFilter: ['open'] });
    // weave drawer controls added for Alu Affäire: phone back arrow + See my model
    modal.addEventListener('click', function (e) {
      if (!on()) return;
      // Affaire: there is no material drawer behind the weave drawer - the arrow and a click beside the panel close it
      if (aff() && (e.target.closest('[data-wg-back]') || e.target === modal)) { e.stopPropagation(); apply(); return; }
      if (e.target.closest('[data-wg-back]')) { e.stopPropagation(); modal.hidden = true; if (st) { st.active = 'frame'; render(); } return; }
      if (e.target.closest('[data-wg-seemodel]')) { e.stopPropagation(); apply(); }
    });
    // phones: iOS swallows a tap as "hover" when the page is still updating from the previous tap (Apply to seat, then
    // Apply to back needed two taps). Buttons in the weave drawer fire on finger-up instead; the late native click is dropped.
    var tapStart = null;
    modal.addEventListener('pointerdown', function (e) { tapStart = e.pointerType === 'touch' ? { x: e.clientX, y: e.clientY } : null; }, true);
    modal.addEventListener('pointerup', function (e) {
      if (!on() || e.pointerType !== 'touch' || !tapStart) return;
      var moved = Math.abs(e.clientX - tapStart.x) > 10 || Math.abs(e.clientY - tapStart.y) > 10; tapStart = null;
      var b = e.target.closest && e.target.closest('button'); if (moved || !b || !modal.contains(b) || b.disabled) return;
      b.__adTap = Date.now();
      b.click();
    }, true);
    modal.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('button');
      if (e.isTrusted && b && b.__adTap && Date.now() - b.__adTap < 3000) { b.__adTap = 0; e.stopImmediatePropagation(); e.preventDefault(); }
    }, true);
    // the weave drawer is left on its own (e.g. drawer not open): keep the split in step
    new MutationObserver(function () {
      if (modal.hidden) { drawer.classList.remove('cpg-ad--split'); if (st && st.active === 'weave' && drawer.hasAttribute('open')) { st.active = 'frame'; render(); } }
    }).observe(modal, { attributes: true, attributeFilter: ['hidden'] });
    // "Change style" sits in the header row of the weave drawer on Alu Affäire, next to "Chosen weave style"
    var chg = modal.querySelector('[data-wg-change]'), head = modal.querySelector('.cpg__drawer-head'), nameRow = modal.querySelector('.cpg__drawer-name');
    var chgHome = chg && chg.parentNode, chgNext = chg && chg.nextSibling;
    function placeChange() {
      if (!chg || !head) return;
      if (on()) { if (chg.parentNode !== head) head.appendChild(chg); }
      else if (chg.parentNode !== chgHome) chgHome.insertBefore(chg, chgNext && chgNext.parentNode === chgHome ? chgNext : null);
    }

    // ---------------- page: desktop summary rows, Options section, phone block
    var cush = root.querySelector('.cpg-cushion[data-cpg-cushion]');
    var frameField = root.querySelector('[data-cpg-field="frame"]');
    var sum = document.createElement('div'); sum.className = 'cpg-asum';
    sum.innerHTML =
      '<div class="cpg-sum__row" role="button" tabindex="0" data-ad-open="frame"><span class="cpg__label cpg-sum__label">Frame color</span>' +
        '<span class="cpg-sum__val" data-v="frame"></span><span class="cpg-sum__img" data-i="frame"></span>' + CHEV + '</div>' +
      '<div class="cpg-sum__row" role="button" tabindex="0" data-ad-open="weave"><span class="cpg__label cpg-sum__label">Weave</span>' +
        '<span class="cpg-sum__val" data-v="weave"></span><span class="cpg-asum__sub" data-v="cols"></span><span class="cpg-sum__img" data-i="weave"></span>' + CHEV + '</div>' +
      '<div class="cpg-sum__row" role="button" tabindex="0" data-ad-open="fab" hidden><span class="cpg__label cpg-sum__label">Seat cushion</span>' +
        '<span class="cpg-sum__val" data-v="fab"></span><span class="cpg-sum__add" data-v="fabadd">Add seat cushion</span><span class="cpg-sum__img" data-i="fab"></span>' + CHEV + '</div>';
    var mob = document.createElement('div'); mob.className = 'cpg-amob';
    mob.innerHTML = '<span class="cpg__label cpg-amob__label">Materials</span><div class="cpg-amob__trio">' +
      ['frame', 'pipe', 'weave'].map(function (k) {
        return '<button type="button" class="cpg-amob__part" data-ad-open="' + k + '"><span class="cpg-amob__img" data-i="' + k + '"></span>' +
          '<span class="cpg-amob__plabel">' + (k === 'frame' ? 'Frame' : k === 'pipe' ? 'Pipe' : 'Weave') + '</span><span class="cpg-amob__pname" data-v="' + k + '"></span></button>';
      }).join('') + '</div>' +
      '<button type="button" class="button w-full cpg-amob__btn" data-ad-open="frame"><div class="text-with-icon">Choose materials</div></button>' +
      '<div class="cpg-pinfo cpg-apinfo">' + careHtml() + '</div>';
    var anchor = frameField || root.querySelector('[data-cpg-field="pipe"]');
    if (anchor) { anchor.parentNode.insertBefore(sum, anchor); anchor.parentNode.insertBefore(mob, anchor); }
    var opts = document.createElement('section'); opts.className = 'cpg-aopts';
    opts.innerHTML = '<h2 class="cpg-opts__title">Options</h2><div class="cpg-opts__grid">' +
      '<div class="cpg-opts__col"><h5 class="cpg-opts__head">Materials</h5><div class="cpg-opts__fbody"><div class="cpg-opts__trio">' +
      ['frame', 'pipe', 'weave'].map(function (k) {
        return '<button type="button" class="cpg-opts__part" data-ad-open="' + k + '"><span class="cpg-opts__pimg" data-i="' + k + '"></span>' +
          '<span class="cpg-opts__plabel">' + (k === 'frame' ? 'Frame' : k === 'pipe' ? 'Pipe' : 'Weave') + '</span><span class="cpg-aopts__pname" data-v="' + k + '"></span></button>';
      }).join('') + '</div><div class="cpg-opts__info">' + careHtml('cpg-opts__i').replace(/cpg-opts__i__row/g, 'cpg-opts__irow').replace(/cpg-opts__i__title/g, 'cpg-opts__ititle').replace(/cpg-opts__i__text/g, 'cpg-opts__itext') + '</div></div>' +
      '<button type="button" class="button cpg-opts__btn" data-ad-open="frame">Change materials</button></div>' +
      '<div class="cpg-opts__col" data-col="fab" hidden><h5 class="cpg-opts__head">Seat cushion</h5>' +
      '<div class="cpg-opts__btnrow"><button type="button" class="button cpg-opts__btn" data-ad-open="fab" data-v="fabbtn">Add seat cushion</button></div></div>' +
      '</div>';
    var oldOpts = root.querySelector('.cpg-opts:not(.cpg-aopts)'), more = root.querySelector('.cpg-more');
    if (oldOpts) oldOpts.parentNode.insertBefore(opts, oldOpts.nextSibling); else if (more) root.insertBefore(opts, more); else root.appendChild(opts);

    function onOpen(e) {
      var t = e.target.closest('[data-ad-open]'); if (!t || !on()) return;
      var k = t.getAttribute('data-ad-open');
      if (k === 'fab') { var b = cush && cush.querySelector('[data-cpg-cushion-open]'); if (b) b.click(); return; }
      open(k);
    }
    [sum, mob, opts].forEach(function (el) { el.addEventListener('click', onOpen); });
    sum.addEventListener('keydown', function (e) { if ((e.key === 'Enter' || e.key === ' ') && e.target.matches('.cpg-sum__row')) { e.preventDefault(); e.target.click(); } });

    // two-part image: narrow pipe on the left, wide frame on the right, both running vertically (Exterior's sample look)
    var lastFP = '';
    function loadImg(u) {
      return new Promise(function (res) {
        if (!u) return res(null);
        var im = new Image(); im.onload = function () { res(im); }; im.onerror = function () { res(null); }; im.src = u;
      });
    }
    function drawCover(ctx, im, x, y, w, h) {
      if (!im) { ctx.fillStyle = '#ebe7e5'; ctx.fillRect(x, y, w, h); return; }
      ctx.save(); ctx.beginPath(); ctx.rect(x, y, w, h); ctx.clip();
      ctx.translate(x + w / 2, y + h / 2); ctx.rotate(Math.PI / 2);
      var bw = h, bh = w, s = Math.max(bw / im.width, bh / im.height), dw = im.width * s, dh = im.height * s;
      ctx.drawImage(im, -dw / 2, -dh / 2, dw, dh); ctx.restore();
    }
    function composeFP(fo, po, el) {
      Promise.all([loadImg(fo && fo.img), loadImg(po && po.img)]).then(function (ims) {
        try {
          var S = 264, pw = Math.round(S * 0.3), c = document.createElement('canvas'); c.width = c.height = S;
          var ctx = c.getContext('2d');
          drawCover(ctx, ims[1], 0, 0, pw, S);
          drawCover(ctx, ims[0], pw, 0, S - pw, S);
          ctx.fillStyle = 'rgba(0,0,0,.18)'; ctx.fillRect(pw - 1, 0, 2, S);
          el.setAttribute('style', 'background-image:url("' + c.toDataURL('image/jpeg', 0.9) + '")');
        } catch (e) { el.setAttribute('style', imgStyle(fo)); }
      });
    }
    // switch the shared layout between Alu Affäire (frame/pipe drawer) and Affäire (fixed material, weave drawer only)
    var lastMode = null;
    function applyMode(A) {
      var row = sum.querySelector('.cpg-sum__row');
      row.querySelector('.cpg-sum__label').textContent = A ? 'Material' : 'Frame color';
      row.classList.toggle('is-static', A);
      if (A) { row.removeAttribute('data-ad-open'); row.removeAttribute('role'); row.removeAttribute('tabindex'); }
      else { row.setAttribute('data-ad-open', 'frame'); row.setAttribute('role', 'button'); row.setAttribute('tabindex', '0'); }
      [mob, opts].forEach(function (box) {
        box.querySelectorAll('.cpg-amob__part, .cpg-opts__part').forEach(function (b) {
          var k = b.querySelector('[data-i]').getAttribute('data-i');
          if (k === 'weave') return;
          b.classList.toggle('is-static', A);
          if (A) b.removeAttribute('data-ad-open'); else b.setAttribute('data-ad-open', k);
        });
      });
      var mb = mob.querySelector('.cpg-amob__btn'); mb.setAttribute('data-ad-open', A ? 'weave' : 'frame');
      mb.querySelector('.text-with-icon').textContent = A ? 'Choose weave' : 'Choose materials';
      var ob = opts.querySelector('.cpg-opts__btn[data-ad-open]:not([data-v])'); ob.setAttribute('data-ad-open', A ? 'weave' : 'frame'); ob.textContent = A ? 'Change weave' : 'Change materials';
      mob.querySelector('.cpg-pinfo').innerHTML = careHtml(null, A);
      opts.querySelector('.cpg-opts__info').innerHTML = careHtml('cpg-opts__i', A).replace(/cpg-opts__i__row/g, 'cpg-opts__irow').replace(/cpg-opts__i__title/g, 'cpg-opts__ititle').replace(/cpg-opts__i__text/g, 'cpg-opts__itext');
      lastFP = '';
    }
    var queued = false;
    function update() {
      queued = false;
      placeChange();
      if (!on()) return;
      var A = aff();
      if (A !== lastMode) { lastMode = A; applyMode(A); }
      var ps = partsData(null), byK = {};
      ps.forEach(function (p) { byK[p.k] = p; });
      var fr = itemAt('frame', selIndex('frame'));
      // Frame color = frame + pipe, like Exterior's compiled image (without the bindings): one name when they match, both when not
      var sameFP = byK.frame.name && byK.frame.name === byK.pipe.name;
      sum.querySelector('[data-v="frame"]').textContent = sameFP ? (fr ? fr.name : byK.frame.name) : byK.frame.name + ' / ' + byK.pipe.name;
      var fpKey = (A ? 'aff|' : '') + (byK.frame.o && byK.frame.o.img) + '|' + (byK.pipe.o && byK.pipe.o.img);
      if (fpKey !== lastFP) {
        lastFP = fpKey;
        if (A) sum.querySelector('[data-i="frame"]').setAttribute('style', imgStyle(byK.frame.o));   // one material: its own swatch
        else composeFP(byK.frame.o, byK.pipe.o, sum.querySelector('[data-i="frame"]'));
      }
      sum.querySelector('[data-v="weave"]').textContent = byK.weave.name ? byK.weave.name + ' weave' : '';
      sum.querySelector('[data-v="cols"]').textContent = byK.weave.cols;
      sum.querySelector('[data-i="weave"]').setAttribute('style', imgStyle(byK.weave.o));
      [mob, opts].forEach(function (box) {
        ['frame', 'pipe', 'weave'].forEach(function (k) {
          var im = box.querySelector('[data-i="' + k + '"]'), nm = box.querySelector('[data-v="' + k + '"]');
          if (im) im.setAttribute('style', imgStyle(byK[k].o));
          if (nm) nm.textContent = byK[k].name;
        });
      });
      // seat cushion (only when the model has one)
      var hasCush = !!(cush && !cush.hidden && cush.style.display !== 'none');
      root.classList.toggle('cpg--alu-cush', hasCush);
      var fRow = sum.querySelector('[data-ad-open="fab"]'), fCol = opts.querySelector('[data-col="fab"]');
      fRow.hidden = fCol.hidden = !hasCush;
      if (hasCush) {
        var nameEl = cush.querySelector('[data-cpg-cushion-name]'), rm = cush.querySelector('[data-cpg-cushion-remove]');
        var onC = !!(rm && !rm.hidden), cImg = cush.querySelector('[data-cpg-cushion-img]');
        sum.querySelector('[data-v="fab"]').textContent = onC ? (nameEl ? nameEl.textContent : '') : 'None';
        sum.querySelector('[data-v="fabadd"]').hidden = onC;
        sum.querySelector('[data-i="fab"]').setAttribute('style', onC && cImg ? 'background-image:' + cImg.style.backgroundImage : 'background-image:url("//sika-design.com/cdn/shop/files/None.png?v=1781700131&width=400")');
        opts.querySelector('[data-v="fabbtn"]').textContent = onC ? 'Change fabric' : 'Add seat cushion';
      }
      if (st && drawer.hasAttribute('open')) {
        var sc = drawer.shadowRoot && drawer.shadowRoot.querySelector('[part="body"]'), top = sc ? sc.scrollTop : 0;
        render(); if (sc) sc.scrollTop = top;
      }
    }
    function queue() { if (!queued) { queued = true; requestAnimationFrame(update); } }
    var mo = new MutationObserver(queue);
    ['frame', 'pipe', 'seat'].forEach(function (k) { var dd = root.querySelector('[data-cpg-dd="' + k + '"]'); if (dd) mo.observe(dd, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'style', 'src'] }); });
    if (cush) mo.observe(cush, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['hidden', 'style', 'class'] });
    new MutationObserver(function () { if (!on()) { closeWeave(); } queue(); }).observe(root, { attributes: true, attributeFilter: ['class'] });
    DESK.addEventListener && DESK.addEventListener('change', function () { if (!DESK.matches) drawer.classList.remove('cpg-ad--split'); queue(); });
    queue();
    setTimeout(queue, 1500);
  }
  function boot() {
    var tries = 0;
    (function go() {
      var roots = document.querySelectorAll('.cpg[id^="cpg-"]');
      roots.forEach(function (r) { if (r.querySelector('[data-cpg-dd="seat"]')) init(r); });
      if ((!roots.length || !roots[0].__aluInit) && tries++ < 40) setTimeout(go, 250);
    })();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

/* ---- Options v5 (desktop, approved by Dee 20 Oct 2026 21:18) ----
   Frame color | Materials & care | divider | Seat cushion (1/3 each). The care text gets its own column,
   the Affäire/Alu Options mirror the fabric details of the standard block, and "Fabric width" / "Color fastness"
   read as one line when the cushion column is wide enough. Layout itself is in cpg-material-drawer.css (desktop only). */
(function () {
  function build(opts) {
    var grid = opts.querySelector('.cpg-opts__grid');
    if (!grid || grid.__v5) return;
    var col1 = grid.querySelector('.cpg-opts__col'), info = col1 && col1.querySelector('.cpg-opts__info');
    if (!col1 || !info) return;
    grid.__v5 = true;
    var care = document.createElement('div');
    care.className = 'cpg-opts__col cpg-opts__col--care';
    care.innerHTML = '<h5 class="cpg-opts__head">Materials &amp; care</h5>';
    care.appendChild(info);
    col1.parentNode.insertBefore(care, col1.nextSibling);
    var rule = document.createElement('div'); rule.className = 'cpg-opts__rule'; rule.setAttribute('aria-hidden', 'true');
    care.parentNode.insertBefore(rule, care.nextSibling);
  }
  function oneLine(box) {
    box.querySelectorAll('.cpg-opts__ftext').forEach(function (t) {
      var wide = t.getBoundingClientRect().width >= 340;
      if (!t.__orig) t.__orig = t.innerHTML;
      var h = wide ? t.__orig.replace(/\.?\s*<br\s*\/?>\s*/i, ' \u00b7 ') : t.__orig;
      if (t.innerHTML !== h) t.innerHTML = h;
    });
  }
  function mirror(root) {
    var std = root.querySelector('.cpg-opts:not(.cpg-aopts)'), alu = root.querySelector('.cpg-aopts');
    if (!std || !alu) return;
    var sCol = std.querySelector('[data-col="fab"]'), aCol = alu.querySelector('[data-col="fab"]');
    if (!sCol || !aCol) return;
    var sFab = sCol.querySelector('.cpg-opts__fab'), aFab = aCol.querySelector('.cpg-opts__fab');
    if (!aFab) {
      aFab = document.createElement('div'); aFab.className = 'cpg-opts__fab';
      var row = aCol.querySelector('.cpg-opts__btnrow'); aCol.insertBefore(aFab, row);
      var rm = document.createElement('button'); rm.type = 'button'; rm.className = 'cpg-opts__link'; rm.setAttribute('data-v5-rm', ''); rm.textContent = 'Remove cushion';
      rm.addEventListener('click', function () { var r = root.querySelector('[data-cpg-cushion-remove]'); if (r) r.click(); });
      row.appendChild(rm);
    }
    var empty = sCol.classList.contains('is-empty') || !sFab || !sFab.innerHTML;
    aCol.classList.toggle('is-empty', empty);
    var rmb = aCol.querySelector('[data-v5-rm]'); if (rmb) rmb.hidden = empty;
    var html = empty ? '' : sFab.innerHTML;
    if (aFab.__src !== html) { aFab.__src = html; aFab.innerHTML = html; }
  }
  function run() {
    document.querySelectorAll('.cpg[id^="cpg-"]').forEach(function (root) {
      root.querySelectorAll('.cpg-opts, .cpg-aopts').forEach(build);
      mirror(root);
      root.querySelectorAll('.cpg-opts, .cpg-aopts').forEach(oneLine);
    });
  }
  var t = null;
  function soon() { clearTimeout(t); t = setTimeout(run, 60); }
  function boot() {
    run();
    if (window.MutationObserver) new MutationObserver(function (m) {
      for (var i = 0; i < m.length; i++) { var n = m[i].target; if (n.closest && n.closest('.cpg-opts, .cpg-aopts')) { soon(); return; } }
    }).observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'hidden'] });
    window.addEventListener('resize', soon);
    setTimeout(run, 1500); setTimeout(run, 4000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
